<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    {{ $route.meta.title }}
                    <el-button class="title_btn" @click="moveCreate" type="primary" v-if="isShowCreateBtn">등록</el-button>
                </div>
                <div class="list-content content tab-content">
                    <div class="intro_tab col_2" @click="$router.replace(`/ssamtalk/content/${ssamTalkKey}`)">
                        기본정보
                    </div>
                    <div class="intro_tab col_2 active">
                        스탭
                    </div>
                </div>
                <div class="list-content">
                    <ssam-talk-detail-component :ssam-talk-type="'ssamtalkStepInfo'" :ssam-talk-key="ssamTalkKey"></ssam-talk-detail-component>
<!--                    <ssam-talk-step-list-component :ssam-talk-type="'step'" :ssam-talk-key="ssamTalkKey"></ssam-talk-step-list-component>-->
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
        <ssam-talk-step-modal></ssam-talk-step-modal>
    </div>
</template>

<script>
import SsamTalkDetailComponent from "@/components/ssamtalk/SsamTalkDetailComponent.vue";
import SsamTalkStepModal from "@/components/modal/SsamTalkStepModal.vue";
import EventBus from "@/utils/event-bus";

export default {
    name: "SsamTalkStep",
    mixins: [],
    components: {SsamTalkDetailComponent, SsamTalkStepModal},
    provide() {
        return {
            setIsShowCreateBtn: this.setIsShowCreateBtn,
        };
    },
    props: {},
    data() {
        return {
            ssamTalkKey: this.$route.params.idx,
            isShowCreateBtn: false,
        };
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setIsShowCreateBtn(value) {
            this.isShowCreateBtn = value;
        },
        moveCreate() {
            EventBus.$emit('openStepCreateModal');
        },

    },
    watch: {},
};
</script>
